export default class IndexFile {
    filehandle;
    renameRefSeq;
    /**
     * @param {filehandle} filehandle
     * @param {function} renameRefSeqs
     */
    constructor({ filehandle, renameRefSeq = (n) => n, }) {
        this.filehandle = filehandle;
        this.renameRefSeq = renameRefSeq;
    }
}
//# sourceMappingURL=indexFile.js.map